import type { AnalyticsRowsProps } from '@fourthwall/module-analytics'
import type { MembershipTier } from '@fourthwall/services/dist/MembershipsApiClient'

import type { Tiers } from '../AnalyticsOverview.types'

export const mapTopTiersToAnalyticsRows = (
  tiersCounts?: Tiers[],
  tiersNames?: MembershipTier[],
): AnalyticsRowsProps['rows'] => {
  if (!tiersCounts || !tiersCounts.length || !tiersNames) return []

  const tiersData = tiersCounts.map((tiersCount) => ({
    ...tiersCount,
    ...tiersNames.find((tiersName) => tiersName.id === tiersCount.tierId),
  }))

  return tiersData.map(({ name, count }) => ({
    label: name,
    value: count,
  }))
}
